import { BBDTag, Texto } from '@gravitate-js/excalibrr'

export type Severity = 'low' | 'medium' | 'high'

interface SeverityTagProps {
  severity: Severity | string | null | undefined
  style?: React.CSSProperties
}

export function SeverityTag({ severity, style }: SeverityTagProps) {
  if (!severity) return null

  switch (severity) {
    case 'high':
      return (
        <BBDTag error style={style}>
          High
        </BBDTag>
      )
    case 'medium':
      return (
        <BBDTag warning style={style}>
          Medium
        </BBDTag>
      )
    case 'low':
      return <BBDTag style={style}>Low</BBDTag>
    default:
      return <Texto>{severity}</Texto>
  }
}
